import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import server from '../../../api/server';
import { setOrganisation } from '../../../actions';
import Modal, { ModalBody, ModalFooter } from '../ui/Modal';
import Button from '../ui/Button';
import { TextField, TextAreaField } from '../ui/FormField';

// Redesign of newadmin/DocumentTypeModal.js — same /doctype/create and
// /doctype/edit payloads and the same setOrganisation dispatches.
const EMPTY_DOCUMENT = {
    label: '',
    min_documents: 1,
    description: '',
    category: '',
};

const DocumentTypeModal = ({ open, onClose, edit, index, activeDocument }) => {
    const organisation = useSelector((s) => s.organisation);
    const dispatch = useDispatch();

    const [form, setForm] = useState({ ...EMPTY_DOCUMENT });
    const [disabled, setDisabled] = useState(false);

    // Load the selected document into the form each time the modal opens
    // (port of the old componentDidMount/componentDidUpdate sync).
    useEffect(() => {
        if (open) {
            setForm({ ...EMPTY_DOCUMENT, ...(activeDocument || {}) });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    const setField = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

    const close = () => {
        setForm({ ...EMPTY_DOCUMENT });
        onClose();
    };

    const formSubmit = async (e) => {
        e.preventDefault();
        setDisabled(true);
        if (edit === true) {
            const obj = {
                label: form.label,
                min_documents: form.min_documents,
                description: form.description,
                category: form.category,
            };
            const updated = { ...organisation };
            updated.file_upload_settings.files[index] = obj;
            await server.post('/doctype/edit', {
                organisation_id: organisation.id,
                organisation: updated,
            });
            dispatch(setOrganisation(updated));
        } else {
            const obj = { ...form };
            obj.organisation_id = organisation.id;
            const response = await server.post('/doctype/create', obj);
            if (response.data) {
                dispatch(setOrganisation(response.data));
            }
        }
        setDisabled(false);
        close();
    };

    const deleteDocumentType = async () => {
        const updated = { ...organisation };
        updated.file_upload_settings.files.splice(index, 1);
        await server.post('/doctype/edit', {
            organisation_id: organisation.id,
            organisation: updated,
        });
        dispatch(setOrganisation(updated));
        close();
    };

    return (
        <Modal open={open} onClose={close} title={`${edit === true ? 'Edit' : 'New'} Document Type`} size="lg">
            <form onSubmit={formSubmit} className="flex flex-col flex-1 min-h-0 overflow-hidden">
                <ModalBody className="flex-1">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <TextField
                            label="Document Name"
                            required
                            value={form.label}
                            onChange={(e) => setField('label', e.target.value)}
                            placeholder="Document Name"
                        />
                        <TextField
                            label="Minimum Required Documents"
                            required
                            type="number"
                            value={form.min_documents}
                            onChange={(e) => setField('min_documents', e.target.value)}
                            placeholder="Minimum Required Documents"
                        />
                        <TextField
                            label="Document Category"
                            required
                            value={form.category}
                            onChange={(e) => setField('category', e.target.value)}
                            placeholder="Document Category"
                            className="sm:col-span-2"
                        />
                        <TextAreaField
                            label="Document Description"
                            required
                            rows={3}
                            value={form.description}
                            onChange={(e) => setField('description', e.target.value)}
                            placeholder="Document Description"
                            className="sm:col-span-2"
                        />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button variant="secondary" onClick={close}>
                        Close
                    </Button>
                    {edit === true ? (
                        <Button variant="danger" onClick={deleteDocumentType}>
                            Delete Document Type
                        </Button>
                    ) : null}
                    <Button type="submit" disabled={disabled}>
                        {edit === true ? 'Edit' : 'Add'} Document Type
                    </Button>
                </ModalFooter>
            </form>
        </Modal>
    );
};

export default DocumentTypeModal;
